import { db, getUser } from '../firebaseApp'

// This is only for use in the UI, the db rules provide the real security
class Roles {
  async isOwner(restaurantId: string) {
    const isOwner = await this.hasRole(restaurantId, 'owners')
    if (isOwner) {
      return true
    } else {
      return await this.isAdmin()
    }
  }

  async isStaff(restaurantId: string) {
    const isStaff = await this.hasRole(restaurantId, 'staff')

    if (isStaff) {
      return true
    } else {
      return await this.isOwner(restaurantId)
    }
  }

  async hasRole(restaurantId: string, role: 'staff' | 'owners') {
    const user = getUser()
    if (user) {
      const uid = user.uid
      const snapshot = await db.ref(`restaurants/${restaurantId}/${role}/${uid}`).once('value')
      return snapshot.val() == true
    }

    return false
  }

  async isAdmin() {
    const user = getUser()
    if (user) {
      const uid = user.uid
      const snapshot = await db.ref(`admins/${uid}`).once('value')
      return snapshot.val() == true
    }

    return false
  }

  async deleteAdmin(uid: string) {
    return db.ref(`admins/${uid}`).remove();
  }

}

export default new Roles()
